


export const MyProfile_START = 'MyProfile_START';
export const MyProfile_END = 'MyProfile_END';
export const MyProfile_ERROR = 'MyProfile_ERROR';
export const MyProfile_SUCCESS = 'MyProfile_SUCCESS';
export const MyProfile_FAIL = 'MyProfile_FAIL';
export const IsDataSubmitedSuccessfully='IsDataSubmitedSuccessfully';